import { createSlice } from '@reduxjs/toolkit';

export const BannerInfo = createSlice({
  name: 'bannerDetails',
  initialState: {
    logo: 'albertsons.png',
    logoLink: 'https://www.albertsons.com/account/short-registration.html',
    homePageLink: 'https://www.albertsons.com',
    pharmacyLink: 'https://www.albertsons.com/pharmacy.html',
    heroText: 'Albertsons',
    bannerName: 'albertsons',
  },
  reducers: {
    bannerDetails: (state, action) => {
      state.logo = action.payload.logo;
      state.logoLink = action.payload.logoLink;
      state.homePageLink = action.payload.homePageLink;
      state.pharmacyLink = action.payload.pharmacyLink;
      state.heroText = action.payload.heroText;
      state.bannerName = action.payload.bannerName;
    },
  },
});

export const { bannerDetails } = BannerInfo.actions;

export default BannerInfo.reducer;
